import { FinalColor }    from 'extract-colors/lib/types/Color';
import React             from 'react';
import { extractColors } from 'extract-colors';
import useFetch          from '@widesk-core/hooks/useFetch';

type ImageColor = {
	red: number;
	green: number;
	blue: number;
}

const useExtractColors = (imageUrl: string) => {
	const [colors, setColors] = React.useState<FinalColor[]>();
	const [primaryColor, setPrimaryColor] = React.useState<ImageColor>();

	const { isLoading } = useFetch(async () => {
		const colors = imageUrl ? await extractColors(imageUrl, { pixels: 100 }) : [];

		if (colors.length) {
			setColors(colors);
			const primaryColor = colors[0];
			setPrimaryColor({ red: primaryColor.red, green: primaryColor.green, blue: primaryColor.blue });
		}

	}, true);

	return {
		colors,
		isLoading,
		primaryColor,
	}
}

export default useExtractColors;